export class Post {
	constructor(public category:string, public id:number, public timestamp:string, public type:string, public component, public editing:boolean){

	}
}


// WEBPACK FOOTER //
// ./src/app/post.ts